import React, { useState } from "react";
import { X } from "lucide-react";
import { useT } from "./i18n";

const DOCS = {
  tos: {
    title: "Terms of Service",
    version: "v1.0",
    date: "01.01.2026",
    body: null,
  },
  privacy: {
    title: "Privacy Policy (GDPR)",
    version: "v1.0",
    date: "01.01.2026",
    body: null,
  },
  saft: {
    title: "Token Purchase Agreement (SAFT)",
    version: "v2.1",
    date: "15.03.2026",
    body: null,
  },
  cookie: {
    title: "Cookie Policy",
    version: "v1.0",
    date: "01.01.2026",
    body: null,
  },
  aml: {
    title: "AML / KYC Disclosure",
    version: "v1.0",
    date: "01.01.2026",
    body: null,
  },
};

function getDocBodies(t) {
  return {
    tos: t("legal.tos.body"),
    privacy: t("legal.privacy.body"),
    saft: t("legal.saft.body"),
    cookie: t("legal.cookie.body"),
    aml: t("legal.aml.body"),
  };
}

export function LegalDocModal({ docKey, onClose }) {
  const { t } = useT();
  const bodies = getDocBodies(t);
  const baseDoc = DOCS[docKey];
  if (!baseDoc) return null;
  const doc = { ...baseDoc, body: bodies[docKey] };
  return (
    <div onClick={onClose} style={{
      position: "fixed", inset: 0, background: "rgba(0,0,0,0.85)", zIndex: 500,
      display: "flex", alignItems: "center", justifyContent: "center", padding: 24,
    }} data-testid="legal-modal">
      <div onClick={(e) => e.stopPropagation()} style={{
        background: "#0B0B10", border: "1px solid var(--tg-border-hi)", borderRadius: 20,
        maxWidth: 760, width: "100%", maxHeight: "90vh", overflow: "hidden",
        display: "flex", flexDirection: "column", boxShadow: "0 30px 80px rgba(0,242,255,0.15)",
      }}>
        <div style={{ padding: "20px 28px", borderBottom: "1px solid var(--tg-border)", display: "flex", justifyContent: "space-between", alignItems: "flex-start", gap: 14 }}>
          <div>
            <h3 style={{ margin: 0, fontSize: 22, fontWeight: 800, color: "var(--tg-text)" }}>{doc.title}</h3>
            <div style={{ fontSize: 12, color: "var(--tg-text-hint)", marginTop: 4 }}>
              <span className="tg-eyebrow" style={{ padding: "2px 10px", marginRight: 8 }}>{doc.version}</span>
              {doc.date}
            </div>
          </div>
          <button onClick={onClose} data-testid="legal-modal-close" style={{
            background: "rgba(255,255,255,0.06)", border: "1px solid var(--tg-border)",
            color: "var(--tg-text)", borderRadius: 10, padding: 8, cursor: "pointer",
          }}><X size={18} /></button>
        </div>
        <div style={{ padding: 28, overflowY: "auto", flex: 1 }}>
          <pre style={{
            whiteSpace: "pre-wrap", fontFamily: "inherit", fontSize: 14, lineHeight: 1.7,
            color: "var(--tg-text-dim)", margin: 0,
          }}>{doc.body}</pre>
        </div>
        <div style={{ padding: "16px 28px", borderTop: "1px solid var(--tg-border)", display: "flex", justifyContent: "space-between", alignItems: "center", fontSize: 12, color: "var(--tg-text-hint)" }}>
          <span>© Turbo Global Coin Ltd., Hong Kong</span>
          <a href={`/api/legal/${docKey}`} target="_blank" rel="noreferrer" style={{ color: "var(--tg-blue)" }}>
            {t("legal.download-pdf")}
          </a>
        </div>
      </div>
    </div>
  );
}

export function useLegalModal() {
  const [openDoc, setOpenDoc] = useState(null);
  const close = () => setOpenDoc(null);
  return { openDoc, setOpenDoc, close };
}